import { render, staticRenderFns } from "./PermissionCertificates.vue?vue&type=template&id=3f4c3ae9"
import script from "./PermissionCertificates.vue?vue&type=script&lang=js"
export * from "./PermissionCertificates.vue?vue&type=script&lang=js"
import style0 from "./PermissionCertificates.vue?vue&type=style&index=0&id=3f4c3ae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports